import { DateTime } from "luxon";
import { CaptureDateStats } from "../capture-date-stats";
import { Cell, CellUnit } from "../range-selection";

/** How the capture histogram is bucketed for browsing */
export enum CaptureGranularity {
  /** One cell per calendar day, laid out as a month grid */
  day = "day",
  /** One cell per calendar month, laid out as a year grid */
  month = "month",
}

/** How the capture dates are laid out */
export enum CaptureLayout {
  /** A timeline of the months and days holding captures */
  list = "list",
  /** A month or a year of calendar cells */
  calendar = "calendar",
}

/** The span the calendar may be paged and picked within */
export type Bounds = {
  min: DateTime;
  max: DateTime;
};

/** What CaptureCalendar hands to each of its views */
export type ViewProps = {
  /** The project capture histogram */
  stats: CaptureDateStats;
  /** Inclusive start of the active range */
  startDate?: Date;
  /** Inclusive end of the active range */
  endDate?: Date;
  /** Notify that the user clicked a day or a month */
  onPick(date: DateTime, unit: CellUnit, isShiftHeld: boolean): void;
  /** Notify that the pointer entered a cell, or left it when called with no argument */
  onHover?(cell?: Cell): void;
  /** Notify that the pointer went down on a cell, which may start a drag */
  onPress?(cell: Cell): void;
  /** True while a range is being dragged */
  isDragging?: boolean;
  /** False for a cell that cannot be picked right now */
  isPickable(date: DateTime, unit: CellUnit): boolean;
  /** The month in sight; the month view shows its year */
  month: DateTime;
  /** Notify that the user paged to another month or year */
  onMonthChange(month: DateTime): void;
  /** The span the calendar may be paged within */
  bounds: Bounds;
  /** Switch between the day and the month view */
  onToggleView(): void;
};
